import React from "react";
import "../styles/BadgeList.css"; // Importation du fichier CSS

const BadgeList = ({ badges, mode = "white" }) => {
  return (
    <div className="badge-container">
      {badges.map((badge, index) => (
        <span key={index} className="badge" style={{ backgroundColor: mode === "white" ? 'rgba(255, 255, 255, 0.4)' : badge === 'Smartfix incluse' ? '#4FB897' :'rgba(0, 0, 0, 0.4)', color: mode === "white" ? "#FFF" : "#fff"  }}>
          {badge}
        </span>
      ))}
    </div>
  );
};

export default BadgeList;
